var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gifts"},[_c('gifts-header'),_vm._v(" "),_c('gifts-test-plans'),_vm._v(" "),_c('gifts-how-it-works'),_vm._v(" "),_c('area-faqs',{attrs:{"area":"gifts"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }